import { usePostHog } from '@posthog/react';
import { useCallback } from 'react';

export const useAnalytics = () => {
  const posthog = usePostHog();

  const track = useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      posthog?.capture(event, {
        ...properties,
        page: typeof window !== 'undefined' ? window.location.pathname : undefined,
      });
    },
    [posthog]
  );

  const identify = useCallback((userId: string) => posthog?.identify(userId), [posthog]);

  return { track, identify };
};
